/**
 * Agent dashboard copy for all non-English panel locales.
 */
export const panelAgentDashboardByLang = {
  es: {
    'agent.dashboard.overview.totalEarned': 'Total ganado',
    'agent.dashboard.overview.totalEarnedHint': 'Comisiones + recompensas por nivel (de por vida)',
    'agent.dashboard.overview.directReferrals': 'Referidos directos',
    'agent.dashboard.overview.directDelta': '{{n}} más para desbloquear',
    'agent.dashboard.overview.indirectReferrals': 'Referidos indirectos',
    'agent.dashboard.overview.indirectDelta': '{{n}} más para desbloquear',
    'agent.dashboard.overview.commissionBalance': 'Saldo de comisiones',
    'agent.dashboard.overview.availableToWithdraw': 'Disponible para retirar',
    'agent.dashboard.progress.loadingShort': 'Cargando…',
    'agent.dashboard.direct.title': 'Referidos directos',
    'agent.dashboard.direct.subtitle': 'Hacia el desbloqueo de retiros',
    'agent.dashboard.direct.required': 'referidos directos requeridos',
    'agent.dashboard.direct.axisZero': '0 referidos',
    'agent.dashboard.direct.axisTarget': 'Objetivo {{n}}',
    'agent.dashboard.direct.progress': '{{current}} de {{target}} completados',
    'agent.dashboard.direct.remaining': 'Faltan {{n}}',
    'agent.dashboard.direct.inProgress': 'En curso',
    'agent.dashboard.direct.info':
      'Alcanza 50 referidos directos para activar tu sistema de retiros. Cada referido debe registrarse con tu enlace único.',
    'agent.dashboard.indirect.title': 'Referidos indirectos',
    'agent.dashboard.indirect.subtitle': 'Hacia el desbloqueo de retiros',
    'agent.dashboard.indirect.required': 'referidos indirectos requeridos',
    'agent.dashboard.indirect.axisZero': '0 referidos',
    'agent.dashboard.indirect.axisTarget': 'Objetivo {{n}}',
    'agent.dashboard.indirect.progress': '{{current}} de {{target}} completados',
    'agent.dashboard.indirect.remaining': 'Faltan {{n}}',
    'agent.dashboard.indirect.inProgress': 'En curso',
    'agent.dashboard.indirect.info':
      'Los referidos indirectos provienen de los propios referidos de tus referidos directos.',
    'agent.dashboard.unlock.active.title': 'El sistema de retiros está activo',
    'agent.dashboard.unlock.active.subtitle':
      'Has cumplido ambos requisitos. Los retiros están habilitados.',
    'agent.dashboard.unlock.active.directLabel': 'Referidos directos',
    'agent.dashboard.unlock.active.indirectLabel': 'Referidos indirectos',
    'agent.dashboard.unlock.active.met': 'Cumplido',
    'agent.dashboard.unlock.active.badge': 'Activo',
    'agent.dashboard.unlock.locked.title': 'El sistema de retiros está bloqueado',
    'agent.dashboard.unlock.locked.subtitle':
      'Completa ambos requisitos siguientes para activar tu sistema de retiros',
    'agent.dashboard.unlock.locked.directHeading': 'REFERIDOS DIRECTOS',
    'agent.dashboard.unlock.locked.indirectHeading': 'REFERIDOS INDIRECTOS',
    'agent.dashboard.unlock.locked.pctComplete': '{{pct}}% completado',
    'agent.dashboard.unlock.locked.moreNeeded': '{{n}} más',
    'agent.dashboard.unlock.locked.badge': 'Bloqueado',
    'agent.dashboard.commission.title': 'Desglose de comisiones',
    'agent.dashboard.commission.directRow': 'Referido directo ({{pct}})',
    'agent.dashboard.commission.indirectRow': 'Referido indirecto ({{pct}})',
    'agent.dashboard.commission.directHelper': 'estimado a partir de inversiones de usuarios directos',
    'agent.dashboard.commission.indirectHelper': 'estimado a partir de inversiones de usuarios indirectos',
    'agent.dashboard.commission.footerTitle': 'Proyección del equipo',
    'agent.dashboard.commission.footerHint':
      'Previsión: las ganancias reales aparecen en «Total ganado» arriba.',
    'agent.dashboard.commission.percentPending': '—%',
    'agent.dashboard.recentActivity.title': 'Actividad reciente de referidos',
    'agent.dashboard.recentActivity.viewAll': 'Ver todo',
    'agent.dashboard.recentActivity.col.user': 'Usuario',
    'agent.dashboard.recentActivity.col.type': 'Tipo',
    'agent.dashboard.recentActivity.col.joined': 'Registro',
    'agent.dashboard.recentActivity.col.investment': 'Inversión',
    'agent.dashboard.recentActivity.col.commission': 'Comisión',
    'agent.dashboard.recentActivity.loading': 'Cargando actividad…',
    'agent.dashboard.recentActivity.empty': 'Aún no hay actividad de referidos.',
  },
  de: {
    'agent.dashboard.overview.totalEarned': 'Insgesamt verdient',
    'agent.dashboard.overview.totalEarnedHint': 'Provisionen + Stufenprämien (lebenslang)',
    'agent.dashboard.overview.directReferrals': 'Direkte Empfehlungen',
    'agent.dashboard.overview.directDelta': 'Noch {{n}} bis zur Freischaltung',
    'agent.dashboard.overview.indirectReferrals': 'Indirekte Empfehlungen',
    'agent.dashboard.overview.indirectDelta': 'Noch {{n}} bis zur Freischaltung',
    'agent.dashboard.overview.commissionBalance': 'Provisionsguthaben',
    'agent.dashboard.overview.availableToWithdraw': 'Zur Auszahlung verfügbar',
    'agent.dashboard.progress.loadingShort': 'Laden…',
    'agent.dashboard.direct.title': 'Direkte Empfehlungen',
    'agent.dashboard.direct.subtitle': 'Auf dem Weg zur Auszahlungsfreischaltung',
    'agent.dashboard.direct.required': 'direkte Empfehlungen erforderlich',
    'agent.dashboard.direct.axisZero': '0 Empfehlungen',
    'agent.dashboard.direct.axisTarget': 'Ziel {{n}}',
    'agent.dashboard.direct.progress': '{{current}} von {{target}} erledigt',
    'agent.dashboard.direct.remaining': 'Noch {{n}} nötig',
    'agent.dashboard.direct.inProgress': 'In Bearbeitung',
    'agent.dashboard.direct.info':
      'Erreichen Sie 50 direkte Empfehlungen, um Ihr Auszahlungssystem zu aktivieren. Jede Empfehlung muss sich über Ihren persönlichen Link registrieren.',
    'agent.dashboard.indirect.title': 'Indirekte Empfehlungen',
    'agent.dashboard.indirect.subtitle': 'Auf dem Weg zur Auszahlungsfreischaltung',
    'agent.dashboard.indirect.required': 'indirekte Empfehlungen erforderlich',
    'agent.dashboard.indirect.axisZero': '0 Empfehlungen',
    'agent.dashboard.indirect.axisTarget': 'Ziel {{n}}',
    'agent.dashboard.indirect.progress': '{{current}} von {{target}} erledigt',
    'agent.dashboard.indirect.remaining': 'Noch {{n}} nötig',
    'agent.dashboard.indirect.inProgress': 'In Bearbeitung',
    'agent.dashboard.indirect.info':
      'Indirekte Empfehlungen stammen von den Empfehlungen Ihrer direkten Empfehlungen.',
    'agent.dashboard.unlock.active.title': 'Auszahlungssystem ist aktiv',
    'agent.dashboard.unlock.active.subtitle':
      'Sie haben beide Anforderungen erfüllt. Auszahlungen sind möglich.',
    'agent.dashboard.unlock.active.directLabel': 'Direkte Empfehlungen',
    'agent.dashboard.unlock.active.indirectLabel': 'Indirekte Empfehlungen',
    'agent.dashboard.unlock.active.met': 'Erfüllt',
    'agent.dashboard.unlock.active.badge': 'Aktiv',
    'agent.dashboard.unlock.locked.title': 'Auszahlungssystem derzeit gesperrt',
    'agent.dashboard.unlock.locked.subtitle':
      'Erfüllen Sie beide Anforderungen unten, um Ihr Auszahlungssystem zu aktivieren',
    'agent.dashboard.unlock.locked.directHeading': 'DIREKTE EMPFEHLUNGEN',
    'agent.dashboard.unlock.locked.indirectHeading': 'INDIREKTE EMPFEHLUNGEN',
    'agent.dashboard.unlock.locked.pctComplete': '{{pct}}% erledigt',
    'agent.dashboard.unlock.locked.moreNeeded': 'Noch {{n}}',
    'agent.dashboard.unlock.locked.badge': 'Gesperrt',
    'agent.dashboard.commission.title': 'Provisionsaufschlüsselung',
    'agent.dashboard.commission.directRow': 'Direkte Empfehlung ({{pct}})',
    'agent.dashboard.commission.indirectRow': 'Indirekte Empfehlung ({{pct}})',
    'agent.dashboard.commission.directHelper': 'geschätzt aus Direktinvestitionen',
    'agent.dashboard.commission.indirectHelper': 'geschätzt aus indirekten Nutzerinvestitionen',
    'agent.dashboard.commission.footerTitle': 'Prognose aus dem Team',
    'agent.dashboard.commission.footerHint':
      'Vorhersage — tatsächliche Einnahmen siehe „Insgesamt verdient“ oben.',
    'agent.dashboard.commission.percentPending': '—%',
    'agent.dashboard.recentActivity.title': 'Letzte Empfehlungsaktivität',
    'agent.dashboard.recentActivity.viewAll': 'Alle anzeigen',
    'agent.dashboard.recentActivity.col.user': 'Nutzer',
    'agent.dashboard.recentActivity.col.type': 'Typ',
    'agent.dashboard.recentActivity.col.joined': 'Beitritt',
    'agent.dashboard.recentActivity.col.investment': 'Investition',
    'agent.dashboard.recentActivity.col.commission': 'Provision',
    'agent.dashboard.recentActivity.loading': 'Aktivität wird geladen…',
    'agent.dashboard.recentActivity.empty': 'Noch keine Empfehlungsaktivität.',
  },
  fr: {
    'agent.dashboard.overview.totalEarned': 'Total gagné',
    'agent.dashboard.overview.totalEarnedHint': 'Commissions + récompenses de palier (à vie)',
    'agent.dashboard.overview.directReferrals': 'Parrainages directs',
    'agent.dashboard.overview.directDelta': '{{n}} de plus pour débloquer',
    'agent.dashboard.overview.indirectReferrals': 'Parrainages indirects',
    'agent.dashboard.overview.indirectDelta': '{{n}} de plus pour débloquer',
    'agent.dashboard.overview.commissionBalance': 'Solde des commissions',
    'agent.dashboard.overview.availableToWithdraw': 'Disponible au retrait',
    'agent.dashboard.progress.loadingShort': 'Chargement…',
    'agent.dashboard.direct.title': 'Parrainages directs',
    'agent.dashboard.direct.subtitle': 'Vers le déblocage des retraits',
    'agent.dashboard.direct.required': 'parrainages directs requis',
    'agent.dashboard.direct.axisZero': '0 parrainages',
    'agent.dashboard.direct.axisTarget': 'Objectif {{n}}',
    'agent.dashboard.direct.progress': '{{current}} sur {{target}} terminés',
    'agent.dashboard.direct.remaining': 'Encore {{n}} nécessaires',
    'agent.dashboard.direct.inProgress': 'En cours',
    'agent.dashboard.direct.info':
      'Atteignez 50 parrainages directs pour activer vos retraits. Chaque filleul doit s’inscrire via votre lien personnel.',
    'agent.dashboard.indirect.title': 'Parrainages indirects',
    'agent.dashboard.indirect.subtitle': 'Vers le déblocage des retraits',
    'agent.dashboard.indirect.required': 'parrainages indirects requis',
    'agent.dashboard.indirect.axisZero': '0 parrainages',
    'agent.dashboard.indirect.axisTarget': 'Objectif {{n}}',
    'agent.dashboard.indirect.progress': '{{current}} sur {{target}} terminés',
    'agent.dashboard.indirect.remaining': 'Encore {{n}} nécessaires',
    'agent.dashboard.indirect.inProgress': 'En cours',
    'agent.dashboard.indirect.info':
      'Les parrainages indirects proviennent des filleuls de vos filleuls directs.',
    'agent.dashboard.unlock.active.title': 'Le système de retrait est actif',
    'agent.dashboard.unlock.active.subtitle':
      'Vous avez rempli les deux conditions. Les retraits sont activés.',
    'agent.dashboard.unlock.active.directLabel': 'Parrainages directs',
    'agent.dashboard.unlock.active.indirectLabel': 'Parrainages indirects',
    'agent.dashboard.unlock.active.met': 'Atteint',
    'agent.dashboard.unlock.active.badge': 'Actif',
    'agent.dashboard.unlock.locked.title': 'Le système de retrait est verrouillé',
    'agent.dashboard.unlock.locked.subtitle':
      'Remplissez les deux conditions ci-dessous pour activer vos retraits',
    'agent.dashboard.unlock.locked.directHeading': 'PARRAINAGES DIRECTS',
    'agent.dashboard.unlock.locked.indirectHeading': 'PARRAINAGES INDIRECTS',
    'agent.dashboard.unlock.locked.pctComplete': '{{pct}}% complété',
    'agent.dashboard.unlock.locked.moreNeeded': 'Encore {{n}}',
    'agent.dashboard.unlock.locked.badge': 'Verrouillé',
    'agent.dashboard.commission.title': 'Répartition des commissions',
    'agent.dashboard.commission.directRow': 'Parrainage direct ({{pct}})',
    'agent.dashboard.commission.indirectRow': 'Parrainage indirect ({{pct}})',
    'agent.dashboard.commission.directHelper': 'estimé à partir des investissements directs',
    'agent.dashboard.commission.indirectHelper': 'estimé à partir des investissements indirects',
    'agent.dashboard.commission.footerTitle': 'Projection équipe',
    'agent.dashboard.commission.footerHint':
      'Prévision — les gains réels figurent dans « Total gagné » ci-dessus.',
    'agent.dashboard.commission.percentPending': '—%',
    'agent.dashboard.recentActivity.title': 'Activité récente de parrainage',
    'agent.dashboard.recentActivity.viewAll': 'Tout voir',
    'agent.dashboard.recentActivity.col.user': 'Utilisateur',
    'agent.dashboard.recentActivity.col.type': 'Type',
    'agent.dashboard.recentActivity.col.joined': 'Inscription',
    'agent.dashboard.recentActivity.col.investment': 'Investissement',
    'agent.dashboard.recentActivity.col.commission': 'Commission',
    'agent.dashboard.recentActivity.loading': 'Chargement de l’activité…',
    'agent.dashboard.recentActivity.empty': 'Aucune activité de parrainage pour le moment.',
  },
  ar: {
    'agent.dashboard.overview.totalEarned': 'إجمالي الأرباح',
    'agent.dashboard.overview.totalEarnedHint': 'العمولات + مكافآت المستوى (مدى الحياة)',
    'agent.dashboard.overview.directReferrals': 'الإحالات المباشرة',
    'agent.dashboard.overview.directDelta': '{{n}} إضافية لفتح القفل',
    'agent.dashboard.overview.indirectReferrals': 'الإحالات غير المباشرة',
    'agent.dashboard.overview.indirectDelta': '{{n}} إضافية لفتح القفل',
    'agent.dashboard.overview.commissionBalance': 'رصيد العمولات',
    'agent.dashboard.overview.availableToWithdraw': 'متاح للسحب',
    'agent.dashboard.progress.loadingShort': 'جاري التحميل…',
    'agent.dashboard.direct.title': 'الإحالات المباشرة',
    'agent.dashboard.direct.subtitle': 'نحو تفعيل السحب',
    'agent.dashboard.direct.required': 'إحالات مباشرة مطلوبة',
    'agent.dashboard.direct.axisZero': '0 إحالات',
    'agent.dashboard.direct.axisTarget': 'الهدف {{n}}',
    'agent.dashboard.direct.progress': '{{current}} من {{target}} مكتمل',
    'agent.dashboard.direct.remaining': 'يلزم {{n}} إضافية',
    'agent.dashboard.direct.inProgress': 'قيد التقدم',
    'agent.dashboard.direct.info':
      'احصل على 50 إحالة مباشرة لتفعيل نظام السحب. يجب أن يسجل كل مرشح عبر رابط الإحالة الخاص بك.',
    'agent.dashboard.indirect.title': 'الإحالات غير المباشرة',
    'agent.dashboard.indirect.subtitle': 'نحو تفعيل السحب',
    'agent.dashboard.indirect.required': 'إحالات غير مباشرة مطلوبة',
    'agent.dashboard.indirect.axisZero': '0 إحالات',
    'agent.dashboard.indirect.axisTarget': 'الهدف {{n}}',
    'agent.dashboard.indirect.progress': '{{current}} من {{target}} مكتمل',
    'agent.dashboard.indirect.remaining': 'يلزم {{n}} إضافية',
    'agent.dashboard.indirect.inProgress': 'قيد التقدم',
    'agent.dashboard.indirect.info': 'الإحالات غير المباشرة تأتي من إحالات مرشحيك المباشرين.',
    'agent.dashboard.unlock.active.title': 'نظام السحب مفعّل',
    'agent.dashboard.unlock.active.subtitle': 'استوفيت الشرطين. السحب متاح.',
    'agent.dashboard.unlock.active.directLabel': 'الإحالات المباشرة',
    'agent.dashboard.unlock.active.indirectLabel': 'الإحالات غير المباشرة',
    'agent.dashboard.unlock.active.met': 'مستوفى',
    'agent.dashboard.unlock.active.badge': 'نشط',
    'agent.dashboard.unlock.locked.title': 'نظام السحب مقفل حالياً',
    'agent.dashboard.unlock.locked.subtitle': 'أكمل الشرطين أدناه لتفعيل السحب',
    'agent.dashboard.unlock.locked.directHeading': 'الإحالات المباشرة',
    'agent.dashboard.unlock.locked.indirectHeading': 'الإحالات غير المباشرة',
    'agent.dashboard.unlock.locked.pctComplete': '{{pct}}% مكتمل',
    'agent.dashboard.unlock.locked.moreNeeded': '{{n}} إضافية',
    'agent.dashboard.unlock.locked.badge': 'مقفل',
    'agent.dashboard.commission.title': 'تفصيل العمولات',
    'agent.dashboard.commission.directRow': 'إحالة مباشرة ({{pct}})',
    'agent.dashboard.commission.indirectRow': 'إحالة غير مباشرة ({{pct}})',
    'agent.dashboard.commission.directHelper': 'تقديري من استثمارات المستخدمين المباشرين',
    'agent.dashboard.commission.indirectHelper': 'تقديري من استثمارات المستخدمين غير المباشرين',
    'agent.dashboard.commission.footerTitle': 'متوقع من الفريق',
    'agent.dashboard.commission.footerHint': 'توقع — الأرباح الفعلية في «إجمالي الأرباح» أعلاه.',
    'agent.dashboard.commission.percentPending': '—%',
    'agent.dashboard.recentActivity.title': 'نشاط الإحالة الأخير',
    'agent.dashboard.recentActivity.viewAll': 'عرض الكل',
    'agent.dashboard.recentActivity.col.user': 'المستخدم',
    'agent.dashboard.recentActivity.col.type': 'النوع',
    'agent.dashboard.recentActivity.col.joined': 'تاريخ الانضمام',
    'agent.dashboard.recentActivity.col.investment': 'الاستثمار',
    'agent.dashboard.recentActivity.col.commission': 'العمولة',
    'agent.dashboard.recentActivity.loading': 'جاري تحميل النشاط…',
    'agent.dashboard.recentActivity.empty': 'لا يوجد نشاط إحالة بعد.',
  },
  ja: {
    'agent.dashboard.overview.totalEarned': '累計獲得',
    'agent.dashboard.overview.totalEarnedHint': 'コミッション＋ティア報酬（累計）',
    'agent.dashboard.overview.directReferrals': '直接紹介',
    'agent.dashboard.overview.directDelta': 'あと{{n}}人で解除',
    'agent.dashboard.overview.indirectReferrals': '間接紹介',
    'agent.dashboard.overview.indirectDelta': 'あと{{n}}人で解除',
    'agent.dashboard.overview.commissionBalance': 'コミッション残高',
    'agent.dashboard.overview.availableToWithdraw': '出金可能額',
    'agent.dashboard.progress.loadingShort': '読み込み中…',
    'agent.dashboard.direct.title': '直接紹介',
    'agent.dashboard.direct.subtitle': '出金解除に向けて',
    'agent.dashboard.direct.required': '必要な直接紹介数',
    'agent.dashboard.direct.axisZero': '0人',
    'agent.dashboard.direct.axisTarget': '目標 {{n}}',
    'agent.dashboard.direct.progress': '{{target}}人中{{current}}人達成',
    'agent.dashboard.direct.remaining': 'あと{{n}}人',
    'agent.dashboard.direct.inProgress': '進行中',
    'agent.dashboard.direct.info':
      '出金を有効にするには直接紹介が50人必要です。各人はあなた専用の紹介リンクから登録してください。',
    'agent.dashboard.indirect.title': '間接紹介',
    'agent.dashboard.indirect.subtitle': '出金解除に向けて',
    'agent.dashboard.indirect.required': '必要な間接紹介数',
    'agent.dashboard.indirect.axisZero': '0人',
    'agent.dashboard.indirect.axisTarget': '目標 {{n}}',
    'agent.dashboard.indirect.progress': '{{target}}人中{{current}}人達成',
    'agent.dashboard.indirect.remaining': 'あと{{n}}人',
    'agent.dashboard.indirect.inProgress': '進行中',
    'agent.dashboard.indirect.info': '間接紹介は、直接紹介した方が紹介した人から発生します。',
    'agent.dashboard.unlock.active.title': '出金システムは有効です',
    'agent.dashboard.unlock.active.subtitle': '両方の条件を満たしました。出金が利用できます。',
    'agent.dashboard.unlock.active.directLabel': '直接紹介',
    'agent.dashboard.unlock.active.indirectLabel': '間接紹介',
    'agent.dashboard.unlock.active.met': '達成',
    'agent.dashboard.unlock.active.badge': '有効',
    'agent.dashboard.unlock.locked.title': '出金システムはロック中です',
    'agent.dashboard.unlock.locked.subtitle': '下の2条件を満たすと出金が有効になります',
    'agent.dashboard.unlock.locked.directHeading': '直接紹介',
    'agent.dashboard.unlock.locked.indirectHeading': '間接紹介',
    'agent.dashboard.unlock.locked.pctComplete': '{{pct}}% 完了',
    'agent.dashboard.unlock.locked.moreNeeded': 'あと{{n}}',
    'agent.dashboard.unlock.locked.badge': 'ロック',
    'agent.dashboard.commission.title': 'コミッション内訳',
    'agent.dashboard.commission.directRow': '直接紹介（{{pct}}）',
    'agent.dashboard.commission.indirectRow': '間接紹介（{{pct}}）',
    'agent.dashboard.commission.directHelper': '直接ユーザーの投資からの見積もり',
    'agent.dashboard.commission.indirectHelper': '間接ユーザーの投資からの見積もり',
    'agent.dashboard.commission.footerTitle': 'チームからの予測',
    'agent.dashboard.commission.footerHint': '予測値 — 実際の収益は上の「累計獲得」を参照。',
    'agent.dashboard.commission.percentPending': '—%',
    'agent.dashboard.recentActivity.title': '最近の紹介アクティビティ',
    'agent.dashboard.recentActivity.viewAll': 'すべて表示',
    'agent.dashboard.recentActivity.col.user': 'ユーザー',
    'agent.dashboard.recentActivity.col.type': '種類',
    'agent.dashboard.recentActivity.col.joined': '登録日',
    'agent.dashboard.recentActivity.col.investment': '投資',
    'agent.dashboard.recentActivity.col.commission': 'コミッション',
    'agent.dashboard.recentActivity.loading': '読み込み中…',
    'agent.dashboard.recentActivity.empty': 'まだ紹介アクティビティはありません。',
  },
  ko: {
    'agent.dashboard.overview.totalEarned': '총 적립',
    'agent.dashboard.overview.totalEarnedHint': '커미션 + 등급 보상(누적)',
    'agent.dashboard.overview.directReferrals': '직접 추천',
    'agent.dashboard.overview.directDelta': '잠금 해제까지 {{n}}명 더',
    'agent.dashboard.overview.indirectReferrals': '간접 추천',
    'agent.dashboard.overview.indirectDelta': '잠금 해제까지 {{n}}명 더',
    'agent.dashboard.overview.commissionBalance': '커미션 잔액',
    'agent.dashboard.overview.availableToWithdraw': '출금 가능',
    'agent.dashboard.progress.loadingShort': '불러오는 중…',
    'agent.dashboard.direct.title': '직접 추천',
    'agent.dashboard.direct.subtitle': '출금 잠금 해제까지',
    'agent.dashboard.direct.required': '필요한 직접 추천 수',
    'agent.dashboard.direct.axisZero': '0명',
    'agent.dashboard.direct.axisTarget': '목표 {{n}}',
    'agent.dashboard.direct.progress': '{{target}}명 중 {{current}}명 완료',
    'agent.dashboard.direct.remaining': '{{n}}명 더 필요',
    'agent.dashboard.direct.inProgress': '진행 중',
    'agent.dashboard.direct.info':
      '출금 시스템을 활성화하려면 직접 추천 50명이 필요합니다. 각 추천인은 고유 추천 링크로 가입해야 합니다.',
    'agent.dashboard.indirect.title': '간접 추천',
    'agent.dashboard.indirect.subtitle': '출금 잠금 해제까지',
    'agent.dashboard.indirect.required': '필요한 간접 추천 수',
    'agent.dashboard.indirect.axisZero': '0명',
    'agent.dashboard.indirect.axisTarget': '목표 {{n}}',
    'agent.dashboard.indirect.progress': '{{target}}명 중 {{current}}명 완료',
    'agent.dashboard.indirect.remaining': '{{n}}명 더 필요',
    'agent.dashboard.indirect.inProgress': '진행 중',
    'agent.dashboard.indirect.info': '간접 추천은 직접 추천한 회원이 추천한 사람에서 발생합니다.',
    'agent.dashboard.unlock.active.title': '출금 시스템 활성',
    'agent.dashboard.unlock.active.subtitle': '두 조건을 모두 충족했습니다. 출금이 가능합니다.',
    'agent.dashboard.unlock.active.directLabel': '직접 추천',
    'agent.dashboard.unlock.active.indirectLabel': '간접 추천',
    'agent.dashboard.unlock.active.met': '충족',
    'agent.dashboard.unlock.active.badge': '활성',
    'agent.dashboard.unlock.locked.title': '출금 시스템 잠김',
    'agent.dashboard.unlock.locked.subtitle': '아래 두 조건을 완료하면 출금이 활성화됩니다',
    'agent.dashboard.unlock.locked.directHeading': '직접 추천',
    'agent.dashboard.unlock.locked.indirectHeading': '간접 추천',
    'agent.dashboard.unlock.locked.pctComplete': '{{pct}}% 완료',
    'agent.dashboard.unlock.locked.moreNeeded': '{{n}}명 더',
    'agent.dashboard.unlock.locked.badge': '잠김',
    'agent.dashboard.commission.title': '커미션 내역',
    'agent.dashboard.commission.directRow': '직접 추천 ({{pct}})',
    'agent.dashboard.commission.indirectRow': '간접 추천 ({{pct}})',
    'agent.dashboard.commission.directHelper': '직접 사용자 투자 기준 추정',
    'agent.dashboard.commission.indirectHelper': '간접 사용자 투자 기준 추정',
    'agent.dashboard.commission.footerTitle': '팀 기준 예상',
    'agent.dashboard.commission.footerHint': '예측 — 실제 수익은 위 «총 적립»을 참고하세요.',
    'agent.dashboard.commission.percentPending': '—%',
    'agent.dashboard.recentActivity.title': '최근 추천 활동',
    'agent.dashboard.recentActivity.viewAll': '전체 보기',
    'agent.dashboard.recentActivity.col.user': '사용자',
    'agent.dashboard.recentActivity.col.type': '유형',
    'agent.dashboard.recentActivity.col.joined': '가입일',
    'agent.dashboard.recentActivity.col.investment': '투자',
    'agent.dashboard.recentActivity.col.commission': '커미션',
    'agent.dashboard.recentActivity.loading': '활동 불러오는 중…',
    'agent.dashboard.recentActivity.empty': '아직 추천 활동이 없습니다.',
  },
  'zh-CN': {
    'agent.dashboard.overview.totalEarned': '累计收益',
    'agent.dashboard.overview.totalEarnedHint': '佣金 + 等级奖励（终身）',
    'agent.dashboard.overview.directReferrals': '直推人数',
    'agent.dashboard.overview.directDelta': '还需 {{n}} 人解锁',
    'agent.dashboard.overview.indirectReferrals': '间推人数',
    'agent.dashboard.overview.indirectDelta': '还需 {{n}} 人解锁',
    'agent.dashboard.overview.commissionBalance': '佣金余额',
    'agent.dashboard.overview.availableToWithdraw': '可提现',
    'agent.dashboard.progress.loadingShort': '加载中…',
    'agent.dashboard.direct.title': '直推',
    'agent.dashboard.direct.subtitle': '提现解锁进度',
    'agent.dashboard.direct.required': '所需直推人数',
    'agent.dashboard.direct.axisZero': '0 人',
    'agent.dashboard.direct.axisTarget': '目标 {{n}}',
    'agent.dashboard.direct.progress': '已完成 {{current}} / {{target}}',
    'agent.dashboard.direct.remaining': '还需 {{n}} 人',
    'agent.dashboard.direct.inProgress': '进行中',
    'agent.dashboard.direct.info':
      '达到 50 名直推可激活提现系统。每位直推须通过您的专属推荐链接注册。',
    'agent.dashboard.indirect.title': '间推',
    'agent.dashboard.indirect.subtitle': '提现解锁进度',
    'agent.dashboard.indirect.required': '所需间推人数',
    'agent.dashboard.indirect.axisZero': '0 人',
    'agent.dashboard.indirect.axisTarget': '目标 {{n}}',
    'agent.dashboard.indirect.progress': '已完成 {{current}} / {{target}}',
    'agent.dashboard.indirect.remaining': '还需 {{n}} 人',
    'agent.dashboard.indirect.inProgress': '进行中',
    'agent.dashboard.indirect.info': '间推来自您直推用户所推荐的用户。',
    'agent.dashboard.unlock.active.title': '提现已启用',
    'agent.dashboard.unlock.active.subtitle': '您已满足两项条件，可以提现。',
    'agent.dashboard.unlock.active.directLabel': '直推',
    'agent.dashboard.unlock.active.indirectLabel': '间推',
    'agent.dashboard.unlock.active.met': '已达成',
    'agent.dashboard.unlock.active.badge': '已启用',
    'agent.dashboard.unlock.locked.title': '提现系统当前锁定',
    'agent.dashboard.unlock.locked.subtitle': '完成以下两项要求即可启用提现',
    'agent.dashboard.unlock.locked.directHeading': '直推',
    'agent.dashboard.unlock.locked.indirectHeading': '间推',
    'agent.dashboard.unlock.locked.pctComplete': '已完成 {{pct}}%',
    'agent.dashboard.unlock.locked.moreNeeded': '还需 {{n}}',
    'agent.dashboard.unlock.locked.badge': '已锁定',
    'agent.dashboard.commission.title': '佣金构成',
    'agent.dashboard.commission.directRow': '直推（{{pct}}）',
    'agent.dashboard.commission.indirectRow': '间推（{{pct}}）',
    'agent.dashboard.commission.directHelper': '根据直推用户投资估算',
    'agent.dashboard.commission.indirectHelper': '根据间推用户投资估算',
    'agent.dashboard.commission.footerTitle': '团队预估',
    'agent.dashboard.commission.footerHint': '预测值 — 实际收益见上方「累计收益」。',
    'agent.dashboard.commission.percentPending': '—%',
    'agent.dashboard.recentActivity.title': '最近推荐动态',
    'agent.dashboard.recentActivity.viewAll': '查看全部',
    'agent.dashboard.recentActivity.col.user': '用户',
    'agent.dashboard.recentActivity.col.type': '类型',
    'agent.dashboard.recentActivity.col.joined': '加入时间',
    'agent.dashboard.recentActivity.col.investment': '投资',
    'agent.dashboard.recentActivity.col.commission': '佣金',
    'agent.dashboard.recentActivity.loading': '加载动态中…',
    'agent.dashboard.recentActivity.empty': '暂无推荐动态。',
  },
  pt: {
    'agent.dashboard.overview.totalEarned': 'Total ganho',
    'agent.dashboard.overview.totalEarnedHint': 'Comissões + recompensas de nível (vitalício)',
    'agent.dashboard.overview.directReferrals': 'Indicações diretas',
    'agent.dashboard.overview.directDelta': 'Mais {{n}} para desbloquear',
    'agent.dashboard.overview.indirectReferrals': 'Indicações indiretas',
    'agent.dashboard.overview.indirectDelta': 'Mais {{n}} para desbloquear',
    'agent.dashboard.overview.commissionBalance': 'Saldo de comissões',
    'agent.dashboard.overview.availableToWithdraw': 'Disponível para saque',
    'agent.dashboard.progress.loadingShort': 'Carregando…',
    'agent.dashboard.direct.title': 'Indicações diretas',
    'agent.dashboard.direct.subtitle': 'Rumo ao desbloqueio de saques',
    'agent.dashboard.direct.required': 'indicações diretas necessárias',
    'agent.dashboard.direct.axisZero': '0 indicações',
    'agent.dashboard.direct.axisTarget': 'Meta {{n}}',
    'agent.dashboard.direct.progress': '{{current}} de {{target}} concluídas',
    'agent.dashboard.direct.remaining': 'Faltam {{n}}',
    'agent.dashboard.direct.inProgress': 'Em andamento',
    'agent.dashboard.direct.info':
      'Alcance 50 indicações diretas para ativar o sistema de saques. Cada indicado deve se registrar pelo seu link exclusivo.',
    'agent.dashboard.indirect.title': 'Indicações indiretas',
    'agent.dashboard.indirect.subtitle': 'Rumo ao desbloqueio de saques',
    'agent.dashboard.indirect.required': 'indicações indiretas necessárias',
    'agent.dashboard.indirect.axisZero': '0 indicações',
    'agent.dashboard.indirect.axisTarget': 'Meta {{n}}',
    'agent.dashboard.indirect.progress': '{{current}} de {{target}} concluídas',
    'agent.dashboard.indirect.remaining': 'Faltam {{n}}',
    'agent.dashboard.indirect.inProgress': 'Em andamento',
    'agent.dashboard.indirect.info':
      'Indicações indiretas vêm das próprias indicações dos seus indicados diretos.',
    'agent.dashboard.unlock.active.title': 'Sistema de saques ativo',
    'agent.dashboard.unlock.active.subtitle':
      'Você cumpriu os dois requisitos. Saques estão habilitados.',
    'agent.dashboard.unlock.active.directLabel': 'Indicações diretas',
    'agent.dashboard.unlock.active.indirectLabel': 'Indicações indiretas',
    'agent.dashboard.unlock.active.met': 'Cumprido',
    'agent.dashboard.unlock.active.badge': 'Ativo',
    'agent.dashboard.unlock.locked.title': 'Sistema de saques bloqueado',
    'agent.dashboard.unlock.locked.subtitle':
      'Complete os dois requisitos abaixo para ativar seus saques',
    'agent.dashboard.unlock.locked.directHeading': 'INDICAÇÕES DIRETAS',
    'agent.dashboard.unlock.locked.indirectHeading': 'INDICAÇÕES INDIRETAS',
    'agent.dashboard.unlock.locked.pctComplete': '{{pct}}% concluído',
    'agent.dashboard.unlock.locked.moreNeeded': 'Mais {{n}}',
    'agent.dashboard.unlock.locked.badge': 'Bloqueado',
    'agent.dashboard.commission.title': 'Detalhamento de comissões',
    'agent.dashboard.commission.directRow': 'Indicação direta ({{pct}})',
    'agent.dashboard.commission.indirectRow': 'Indicação indireta ({{pct}})',
    'agent.dashboard.commission.directHelper': 'estimado a partir de investimentos diretos',
    'agent.dashboard.commission.indirectHelper': 'estimado a partir de investimentos indiretos',
    'agent.dashboard.commission.footerTitle': 'Projeção da equipe',
    'agent.dashboard.commission.footerHint':
      'Previsão — os ganhos reais estão em «Total ganho» acima.',
    'agent.dashboard.commission.percentPending': '—%',
    'agent.dashboard.recentActivity.title': 'Atividade recente de indicações',
    'agent.dashboard.recentActivity.viewAll': 'Ver tudo',
    'agent.dashboard.recentActivity.col.user': 'Usuário',
    'agent.dashboard.recentActivity.col.type': 'Tipo',
    'agent.dashboard.recentActivity.col.joined': 'Entrada',
    'agent.dashboard.recentActivity.col.investment': 'Investimento',
    'agent.dashboard.recentActivity.col.commission': 'Comissão',
    'agent.dashboard.recentActivity.loading': 'Carregando atividade…',
    'agent.dashboard.recentActivity.empty': 'Ainda não há atividade de indicações.',
  },
  it: {
    'agent.dashboard.overview.totalEarned': 'Totale guadagnato',
    'agent.dashboard.overview.totalEarnedHint': 'Commissioni + ricompense livello (a vita)',
    'agent.dashboard.overview.directReferrals': 'Referral diretti',
    'agent.dashboard.overview.directDelta': 'Altri {{n}} per sbloccare',
    'agent.dashboard.overview.indirectReferrals': 'Referral indiretti',
    'agent.dashboard.overview.indirectDelta': 'Altri {{n}} per sbloccare',
    'agent.dashboard.overview.commissionBalance': 'Saldo commissioni',
    'agent.dashboard.overview.availableToWithdraw': 'Disponibile al prelievo',
    'agent.dashboard.progress.loadingShort': 'Caricamento…',
    'agent.dashboard.direct.title': 'Referral diretti',
    'agent.dashboard.direct.subtitle': 'Verso lo sblocco dei prelievi',
    'agent.dashboard.direct.required': 'referral diretti richiesti',
    'agent.dashboard.direct.axisZero': '0 referral',
    'agent.dashboard.direct.axisTarget': 'Obiettivo {{n}}',
    'agent.dashboard.direct.progress': '{{current}} di {{target}} completati',
    'agent.dashboard.direct.remaining': 'Ne servono altri {{n}}',
    'agent.dashboard.direct.inProgress': 'In corso',
    'agent.dashboard.direct.info':
      'Raggiungi 50 referral diretti per attivare i prelievi. Ogni referral deve registrarsi con il tuo link personale.',
    'agent.dashboard.indirect.title': 'Referral indiretti',
    'agent.dashboard.indirect.subtitle': 'Verso lo sblocco dei prelievi',
    'agent.dashboard.indirect.required': 'referral indiretti richiesti',
    'agent.dashboard.indirect.axisZero': '0 referral',
    'agent.dashboard.indirect.axisTarget': 'Obiettivo {{n}}',
    'agent.dashboard.indirect.progress': '{{current}} di {{target}} completati',
    'agent.dashboard.indirect.remaining': 'Ne servono altri {{n}}',
    'agent.dashboard.indirect.inProgress': 'In corso',
    'agent.dashboard.indirect.info':
      'I referral indiretti provengono dai referral dei tuoi referral diretti.',
    'agent.dashboard.unlock.active.title': 'Sistema di prelievo attivo',
    'agent.dashboard.unlock.active.subtitle':
      'Hai soddisfatto entrambi i requisiti. I prelievi sono abilitati.',
    'agent.dashboard.unlock.active.directLabel': 'Referral diretti',
    'agent.dashboard.unlock.active.indirectLabel': 'Referral indiretti',
    'agent.dashboard.unlock.active.met': 'Soddisfatto',
    'agent.dashboard.unlock.active.badge': 'Attivo',
    'agent.dashboard.unlock.locked.title': 'Sistema di prelievo bloccato',
    'agent.dashboard.unlock.locked.subtitle':
      'Completa entrambi i requisiti qui sotto per attivare i prelievi',
    'agent.dashboard.unlock.locked.directHeading': 'REFERRAL DIRETTI',
    'agent.dashboard.unlock.locked.indirectHeading': 'REFERRAL INDIRETTI',
    'agent.dashboard.unlock.locked.pctComplete': '{{pct}}% completato',
    'agent.dashboard.unlock.locked.moreNeeded': 'Altri {{n}}',
    'agent.dashboard.unlock.locked.badge': 'Bloccato',
    'agent.dashboard.commission.title': 'Dettaglio commissioni',
    'agent.dashboard.commission.directRow': 'Referral diretto ({{pct}})',
    'agent.dashboard.commission.indirectRow': 'Referral indiretto ({{pct}})',
    'agent.dashboard.commission.directHelper': 'stima da investimenti utenti diretti',
    'agent.dashboard.commission.indirectHelper': 'stima da investimenti utenti indiretti',
    'agent.dashboard.commission.footerTitle': 'Proiezione dal team',
    'agent.dashboard.commission.footerHint':
      'Previsione — i guadagni reali sono in «Totale guadagnato» sopra.',
    'agent.dashboard.commission.percentPending': '—%',
    'agent.dashboard.recentActivity.title': 'Attività referral recente',
    'agent.dashboard.recentActivity.viewAll': 'Vedi tutto',
    'agent.dashboard.recentActivity.col.user': 'Utente',
    'agent.dashboard.recentActivity.col.type': 'Tipo',
    'agent.dashboard.recentActivity.col.joined': 'Iscrizione',
    'agent.dashboard.recentActivity.col.investment': 'Investimento',
    'agent.dashboard.recentActivity.col.commission': 'Commissione',
    'agent.dashboard.recentActivity.loading': 'Caricamento attività…',
    'agent.dashboard.recentActivity.empty': 'Nessuna attività referral ancora.',
  },
  ru: {
    'agent.dashboard.overview.totalEarned': 'Всего заработано',
    'agent.dashboard.overview.totalEarnedHint': 'Комиссии + награды уровня (за всё время)',
    'agent.dashboard.overview.directReferrals': 'Прямые рефералы',
    'agent.dashboard.overview.directDelta': 'Ещё {{n}} для разблокировки',
    'agent.dashboard.overview.indirectReferrals': 'Косвенные рефералы',
    'agent.dashboard.overview.indirectDelta': 'Ещё {{n}} для разблокировки',
    'agent.dashboard.overview.commissionBalance': 'Баланс комиссий',
    'agent.dashboard.overview.availableToWithdraw': 'Доступно к выводу',
    'agent.dashboard.progress.loadingShort': 'Загрузка…',
    'agent.dashboard.direct.title': 'Прямые рефералы',
    'agent.dashboard.direct.subtitle': 'К разблокировке вывода',
    'agent.dashboard.direct.required': 'требуется прямых рефералов',
    'agent.dashboard.direct.axisZero': '0 рефералов',
    'agent.dashboard.direct.axisTarget': 'Цель {{n}}',
    'agent.dashboard.direct.progress': '{{current}} из {{target}} выполнено',
    'agent.dashboard.direct.remaining': 'Нужно ещё {{n}}',
    'agent.dashboard.direct.inProgress': 'В процессе',
    'agent.dashboard.direct.info':
      'Наберите 50 прямых рефералов, чтобы активировать вывод. Каждый должен зарегистрироваться по вашей ссылке.',
    'agent.dashboard.indirect.title': 'Косвенные рефералы',
    'agent.dashboard.indirect.subtitle': 'К разблокировке вывода',
    'agent.dashboard.indirect.required': 'требуется косвенных рефералов',
    'agent.dashboard.indirect.axisZero': '0 рефералов',
    'agent.dashboard.indirect.axisTarget': 'Цель {{n}}',
    'agent.dashboard.indirect.progress': '{{current}} из {{target}} выполнено',
    'agent.dashboard.indirect.remaining': 'Нужно ещё {{n}}',
    'agent.dashboard.indirect.inProgress': 'В процессе',
    'agent.dashboard.indirect.info':
      'Косвенные рефералы — это рефералы ваших прямых рефералов.',
    'agent.dashboard.unlock.active.title': 'Вывод средств активен',
    'agent.dashboard.unlock.active.subtitle':
      'Оба условия выполнены. Вывод доступен.',
    'agent.dashboard.unlock.active.directLabel': 'Прямые рефералы',
    'agent.dashboard.unlock.active.indirectLabel': 'Косвенные рефералы',
    'agent.dashboard.unlock.active.met': 'Выполнено',
    'agent.dashboard.unlock.active.badge': 'Активно',
    'agent.dashboard.unlock.locked.title': 'Вывод средств заблокирован',
    'agent.dashboard.unlock.locked.subtitle':
      'Выполните оба условия ниже, чтобы активировать вывод',
    'agent.dashboard.unlock.locked.directHeading': 'ПРЯМЫЕ РЕФЕРАЛЫ',
    'agent.dashboard.unlock.locked.indirectHeading': 'КОСВЕННЫЕ РЕФЕРАЛЫ',
    'agent.dashboard.unlock.locked.pctComplete': '{{pct}}% выполнено',
    'agent.dashboard.unlock.locked.moreNeeded': 'Ещё {{n}}',
    'agent.dashboard.unlock.locked.badge': 'Заблокировано',
    'agent.dashboard.commission.title': 'Разбивка комиссий',
    'agent.dashboard.commission.directRow': 'Прямой реферал ({{pct}})',
    'agent.dashboard.commission.indirectRow': 'Косвенный реферал ({{pct}})',
    'agent.dashboard.commission.directHelper': 'оценка по инвестициям прямых пользователей',
    'agent.dashboard.commission.indirectHelper': 'оценка по инвестициям косвенных пользователей',
    'agent.dashboard.commission.footerTitle': 'Прогноз по команде',
    'agent.dashboard.commission.footerHint':
      'Прогноз — фактический доход в «Всего заработано» выше.',
    'agent.dashboard.commission.percentPending': '—%',
    'agent.dashboard.recentActivity.title': 'Недавняя активность рефералов',
    'agent.dashboard.recentActivity.viewAll': 'Показать все',
    'agent.dashboard.recentActivity.col.user': 'Пользователь',
    'agent.dashboard.recentActivity.col.type': 'Тип',
    'agent.dashboard.recentActivity.col.joined': 'Регистрация',
    'agent.dashboard.recentActivity.col.investment': 'Инвестиции',
    'agent.dashboard.recentActivity.col.commission': 'Комиссия',
    'agent.dashboard.recentActivity.loading': 'Загрузка активности…',
    'agent.dashboard.recentActivity.empty': 'Пока нет активности рефералов.',
  },
  bn: {
    'agent.dashboard.overview.totalEarned': 'মোট আয়',
    'agent.dashboard.overview.totalEarnedHint': 'কমিশন + স্তর পুরস্কার (জীবনকাল)',
    'agent.dashboard.overview.directReferrals': 'সরাসরি রেফারেল',
    'agent.dashboard.overview.directDelta': 'আনলক করতে আরও {{n}}',
    'agent.dashboard.overview.indirectReferrals': 'পরোক্ষ রেফারেল',
    'agent.dashboard.overview.indirectDelta': 'আনলক করতে আরও {{n}}',
    'agent.dashboard.overview.commissionBalance': 'কমিশন ব্যালেন্স',
    'agent.dashboard.overview.availableToWithdraw': 'উত্তোলনের জন্য উপলব্ধ',
    'agent.dashboard.progress.loadingShort': 'লোড হচ্ছে…',
    'agent.dashboard.direct.title': 'সরাসরি রেফারেল',
    'agent.dashboard.direct.subtitle': 'উত্তোলন আনলকের দিকে',
    'agent.dashboard.direct.required': 'প্রয়োজনীয় সরাসরি রেফারেল',
    'agent.dashboard.direct.axisZero': '০ রেফারেল',
    'agent.dashboard.direct.axisTarget': 'লক্ষ্য {{n}}',
    'agent.dashboard.direct.progress': '{{target}}-এর মধ্যে {{current}} সম্পন্ন',
    'agent.dashboard.direct.remaining': 'আরও {{n}} প্রয়োজন',
    'agent.dashboard.direct.inProgress': 'চলমান',
    'agent.dashboard.direct.info':
      'উত্তোলন সক্রিয় করতে ৫০ সরাসরি রেফারেল প্রয়োজন। প্রত্যেককে আপনার অনন্য লিংক দিয়ে নিবন্ধন করতে হবে।',
    'agent.dashboard.indirect.title': 'পরোক্ষ রেফারেল',
    'agent.dashboard.indirect.subtitle': 'উত্তোলন আনলকের দিকে',
    'agent.dashboard.indirect.required': 'প্রয়োজনীয় পরোক্ষ রেফারেল',
    'agent.dashboard.indirect.axisZero': '০ রেফারেল',
    'agent.dashboard.indirect.axisTarget': 'লক্ষ্য {{n}}',
    'agent.dashboard.indirect.progress': '{{target}}-এর মধ্যে {{current}} সম্পন্ন',
    'agent.dashboard.indirect.remaining': 'আরও {{n}} প্রয়োজন',
    'agent.dashboard.indirect.inProgress': 'চলমান',
    'agent.dashboard.indirect.info':
      'পরোক্ষ রেফারেল আসে আপনার সরাসরি রেফারেলদের নিজস্ব রেফারেল থেকে।',
    'agent.dashboard.unlock.active.title': 'উত্তোলন সিস্টেম সক্রিয়',
    'agent.dashboard.unlock.active.subtitle':
      'আপনি উভয় শর্ত পূরণ করেছেন। উত্তোলন সক্ষম।',
    'agent.dashboard.unlock.active.directLabel': 'সরাসরি রেফারেল',
    'agent.dashboard.unlock.active.indirectLabel': 'পরোক্ষ রেফারেল',
    'agent.dashboard.unlock.active.met': 'পূরণ হয়েছে',
    'agent.dashboard.unlock.active.badge': 'সক্রিয়',
    'agent.dashboard.unlock.locked.title': 'উত্তোলন সিস্টেম বর্তমানে লক',
    'agent.dashboard.unlock.locked.subtitle':
      'উত্তোলন সক্রিয় করতে নিচের উভয় শর্ত সম্পূর্ণ করুন',
    'agent.dashboard.unlock.locked.directHeading': 'সরাসরি রেফারেল',
    'agent.dashboard.unlock.locked.indirectHeading': 'পরোক্ষ রেফারেল',
    'agent.dashboard.unlock.locked.pctComplete': '{{pct}}% সম্পন্ন',
    'agent.dashboard.unlock.locked.moreNeeded': 'আরও {{n}}',
    'agent.dashboard.unlock.locked.badge': 'লক',
    'agent.dashboard.commission.title': 'কমিশন বিভাজন',
    'agent.dashboard.commission.directRow': 'সরাসরি রেফারেল ({{pct}})',
    'agent.dashboard.commission.indirectRow': 'পরোক্ষ রেফারেল ({{pct}})',
    'agent.dashboard.commission.directHelper': 'সরাসরি ব্যবহারকারী বিনিয়োগ থেকে অনুমান',
    'agent.dashboard.commission.indirectHelper': 'পরোক্ষ ব্যবহারকারী বিনিয়োগ থেকে অনুমান',
    'agent.dashboard.commission.footerTitle': 'দল থেকে প্রক্ষেপণ',
    'agent.dashboard.commission.footerHint':
      'পূর্বাভাস — প্রকৃত আয় উপরে «মোট আয়»-এ।',
    'agent.dashboard.commission.percentPending': '—%',
    'agent.dashboard.recentActivity.title': 'সাম্প্রতিক রেফারেল কার্যকলাপ',
    'agent.dashboard.recentActivity.viewAll': 'সব দেখুন',
    'agent.dashboard.recentActivity.col.user': 'ব্যবহারকারী',
    'agent.dashboard.recentActivity.col.type': 'ধরন',
    'agent.dashboard.recentActivity.col.joined': 'যোগদান',
    'agent.dashboard.recentActivity.col.investment': 'বিনিয়োগ',
    'agent.dashboard.recentActivity.col.commission': 'কমিশন',
    'agent.dashboard.recentActivity.loading': 'কার্যকলাপ লোড হচ্ছে…',
    'agent.dashboard.recentActivity.empty': 'এখনও কোনো রেফারেল কার্যকলাপ নেই।',
  },
  hi: {
    'agent.dashboard.overview.totalEarned': 'कुल कमाई',
    'agent.dashboard.overview.totalEarnedHint': 'कमीशन + स्तर पुरस्कार (जीवनकाल)',
    'agent.dashboard.overview.directReferrals': 'प्रत्यक्ष रेफ़रल',
    'agent.dashboard.overview.directDelta': 'अनलॉक के लिए और {{n}}',
    'agent.dashboard.overview.indirectReferrals': 'अप्रत्यक्ष रेफ़रल',
    'agent.dashboard.overview.indirectDelta': 'अनलॉक के लिए और {{n}}',
    'agent.dashboard.overview.commissionBalance': 'कमीशन बैलेंस',
    'agent.dashboard.overview.availableToWithdraw': 'निकासी के लिए उपलब्ध',
    'agent.dashboard.progress.loadingShort': 'लोड हो रहा है…',
    'agent.dashboard.direct.title': 'प्रत्यक्ष रेफ़रल',
    'agent.dashboard.direct.subtitle': 'निकासी अनलॉक की ओर',
    'agent.dashboard.direct.required': 'आवश्यक प्रत्यक्ष रेफ़रल',
    'agent.dashboard.direct.axisZero': '0 रेफ़रल',
    'agent.dashboard.direct.axisTarget': 'लक्ष्य {{n}}',
    'agent.dashboard.direct.progress': '{{target}} में से {{current}} पूरे',
    'agent.dashboard.direct.remaining': 'और {{n}} चाहिए',
    'agent.dashboard.direct.inProgress': 'प्रगति में',
    'agent.dashboard.direct.info':
      'निकासी सक्रिय करने के लिए 50 प्रत्यक्ष रेफ़रल चाहिए। प्रत्येक को आपके विशिष्ट लिंक से पंजीकरण करना होगा।',
    'agent.dashboard.indirect.title': 'अप्रत्यक्ष रेफ़रल',
    'agent.dashboard.indirect.subtitle': 'निकासी अनलॉक की ओर',
    'agent.dashboard.indirect.required': 'आवश्यक अप्रत्यक्ष रेफ़रल',
    'agent.dashboard.indirect.axisZero': '0 रेफ़रल',
    'agent.dashboard.indirect.axisTarget': 'लक्ष्य {{n}}',
    'agent.dashboard.indirect.progress': '{{target}} में से {{current}} पूरे',
    'agent.dashboard.indirect.remaining': 'और {{n}} चाहिए',
    'agent.dashboard.indirect.inProgress': 'प्रगति में',
    'agent.dashboard.indirect.info':
      'अप्रत्यक्ष रेफ़रल आपके प्रत्यक्ष रेफ़रल के अपने रेफ़रल से आते हैं।',
    'agent.dashboard.unlock.active.title': 'निकासी प्रणाली सक्रिय है',
    'agent.dashboard.unlock.active.subtitle':
      'आपने दोनों शर्तें पूरी की हैं। निकासी सक्षम है।',
    'agent.dashboard.unlock.active.directLabel': 'प्रत्यक्ष रेफ़रल',
    'agent.dashboard.unlock.active.indirectLabel': 'अप्रत्यक्ष रेफ़रल',
    'agent.dashboard.unlock.active.met': 'पूरा',
    'agent.dashboard.unlock.active.badge': 'सक्रिय',
    'agent.dashboard.unlock.locked.title': 'निकासी प्रणाली अभी लॉक है',
    'agent.dashboard.unlock.locked.subtitle':
      'निकासी सक्रिय करने के लिए नीचे दोनों शर्तें पूरी करें',
    'agent.dashboard.unlock.locked.directHeading': 'प्रत्यक्ष रेफ़रल',
    'agent.dashboard.unlock.locked.indirectHeading': 'अप्रत्यक्ष रेफ़रल',
    'agent.dashboard.unlock.locked.pctComplete': '{{pct}}% पूरा',
    'agent.dashboard.unlock.locked.moreNeeded': 'और {{n}}',
    'agent.dashboard.unlock.locked.badge': 'लॉक',
    'agent.dashboard.commission.title': 'कमीशन विवरण',
    'agent.dashboard.commission.directRow': 'प्रत्यक्ष रेफ़रल ({{pct}})',
    'agent.dashboard.commission.indirectRow': 'अप्रत्यक्ष रेफ़रल ({{pct}})',
    'agent.dashboard.commission.directHelper': 'प्रत्यक्ष उपयोगकर्ता निवेश से अनुमान',
    'agent.dashboard.commission.indirectHelper': 'अप्रत्यक्ष उपयोगकर्ता निवेश से अनुमान',
    'agent.dashboard.commission.footerTitle': 'टीम से अनुमान',
    'agent.dashboard.commission.footerHint':
      'पूर्वानुमान — वास्तविक कमाई ऊपर «कुल कमाई» में।',
    'agent.dashboard.commission.percentPending': '—%',
    'agent.dashboard.recentActivity.title': 'हाल की रेफ़रल गतिविधि',
    'agent.dashboard.recentActivity.viewAll': 'सभी देखें',
    'agent.dashboard.recentActivity.col.user': 'उपयोगकर्ता',
    'agent.dashboard.recentActivity.col.type': 'प्रकार',
    'agent.dashboard.recentActivity.col.joined': 'शामिल हुए',
    'agent.dashboard.recentActivity.col.investment': 'निवेश',
    'agent.dashboard.recentActivity.col.commission': 'कमीशन',
    'agent.dashboard.recentActivity.loading': 'गतिविधि लोड हो रही है…',
    'agent.dashboard.recentActivity.empty': 'अभी तक कोई रेफ़रल गतिविधि नहीं।',
  },
};
